// DS9.5
import React from 'react';
import c from 'classnames';
import Button from '../Buttons/GhostButton';
import SolidButton from '../Buttons/SolidButton';
import s from './EmptyState.scss';
var EmptyState = function (_a) {
    var className = _a.className, titleClassName = _a.titleClassName, subtitleClassName = _a.subtitleClassName, withIllustrationBelow = _a.withIllustrationBelow, title = _a.title, subtitle = _a.subtitle, illustration = _a.illustration, illustrationClassName = _a.illustrationClassName, withButton = _a.withButton, buttonLabel = _a.buttonLabel, buttonVariant = _a.buttonVariant, customButton = _a.customButton, customSecondaryButton = _a.customSecondaryButton, onButtonClick = _a.onButtonClick, biData = _a.biData;
    return (React.createElement("div", { className: c(s['root'], className) },
        illustration && (React.createElement("div", { className: c(s['illustration'], withIllustrationBelow && s['illustration-below'], illustrationClassName) }, illustration)),
        React.createElement("div", { className: c(s['title'], titleClassName) }, title),
        React.createElement("div", { className: c(s['subtitle'], subtitleClassName) }, subtitle),
        React.createElement("div", { className: s['buttons'] },
            customSecondaryButton,
            customButton ||
                (withButton &&
                    (buttonVariant ? (React.createElement(SolidButton, { variant: buttonVariant, size: "medium", onClick: onButtonClick, biData: biData }, buttonLabel)) : (React.createElement(Button, { variant: "main", size: "medium", onClick: onButtonClick, biData: biData }, buttonLabel)))))));
};
EmptyState.displayName = 'EmptyState';
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map